import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BbgTickerFormField } from '@/pages/instruments/new-instrument/form-fields/BbgTickerFormField'
import { CompanyNameFormField } from '@/pages/instruments/new-instrument/form-fields/CompanyNameFormField'
import { CounterpartyIdField } from '@/pages/instruments/new-instrument/form-fields/CounterpartyIdField'
import { CountryIdFormField } from '@/pages/instruments/new-instrument/form-fields/CountryIdFormField'
import { CurrencyIdField } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdField'
import { DescriptionFormField } from '@/pages/instruments/new-instrument/form-fields/DescriptionFormField'
import { ISINField } from '@/pages/instruments/new-instrument/form-fields/ISINField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { EquitySchemaType } from '@/pages/instruments/new-instrument/schemas/equity.schema'

export interface EquityFormFieldsProps {}

export const EquityFormFields: React.FC<EquityFormFieldsProps> = ({}) => {
  const { trigger } = useFormContext<EquitySchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-4'}>
      <FormFieldRow>
        <ISINField />
        <BbgTickerFormField placeholder={'GOOG UW Equity'} />
        <CompanyNameFormField />
        <CurrencyIdField />
      </FormFieldRow>
      <FormFieldRow>
        <CounterpartyIdField />
        <CountryIdFormField />
        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>
      <DescriptionFormField />
    </div>
  )
}
